/* Central data-testid registry for tests + design coverage */
export const HOME = {
  heroSearchInput: "hero-search-input",
  heroSearchCategory: "hero-search-category",
  heroSearchLocation: "hero-search-location",
  heroSearchButton: "hero-search-button",
  heroAiSearchToggle: "hero-ai-search-toggle",
  postAdBtn: "post-ad-cta",
  featuredSection: "home-featured",
  categoryGrid: "home-category-grid",
};

export const HEADER = {
  root: "header-root",
  logo: "header-logo",
  megaMenuBtn: "header-megamenu-btn",
  postAdBtn: "header-post-ad",
  loginBtn: "header-login",
  registerBtn: "header-register",
  myAdsBtn: "header-my-ads",
  chatBtn: "header-chat",
  logoutBtn: "header-logout-btn",
  adminLink: "header-admin-link",
  userMenu: "header-user-menu",
};

export const LISTING = {
  card: (id) => `listing-card-${id}`,
  cardLink: (id) => `listing-card-link-${id}`,
  favouriteBtn: (id) => `listing-fav-${id}`,
  grid: "listing-grid",
  emptyState: "listing-empty",
};

export const AD = {
  root: "ad-detail",
  title: "ad-title",
  price: "ad-price",
  gallery: "ad-gallery",
  revealPhoneBtn: "ad-reveal-phone",
  revealWhatsappBtn: "ad-reveal-whatsapp",
  phoneNumber: "ad-phone",
  whatsappLink: "ad-whatsapp-link",
  chatSellerBtn: "ad-chat-seller-btn",
  description: "ad-description",
  breadcrumbs: "ad-breadcrumbs",
};

export const POST = {
  form: "post-ad-form",
  title: "post-ad-title",
  description: "post-ad-description",
  price: "post-ad-price",
  category: "post-ad-category",
  region: "post-ad-region",
  city: "post-ad-city",
  phone: "post-ad-phone",
  whatsapp: "post-ad-whatsapp",
  imagesInput: "post-ad-images-input",
  submit: "post-ad-submit",
  aiWriteBtn: "post-ad-ai-write",
  aiKeywords: "post-ad-ai-keywords",
};

export const AUTH = {
  emailInput: "auth-email",
  passwordInput: "auth-password",
  nameInput: "auth-name",
  submit: "auth-submit",
  switchBtn: "auth-switch",
};

export const SEARCH = {
  root: "search-page",
  filterRail: "search-filter-rail",
  filterCategory: "filter-category",
  filterRegion: "filter-region",
  filterCity: "filter-city",
  filterMinPrice: "filter-min-price",
  filterMaxPrice: "filter-max-price",
  filterSort: "filter-sort",
  applyFilters: "filter-apply",
  clearFilters: "filter-clear",
  resultsCount: "search-results-count",
};

export const CHAT = {
  list: "chat-list",
  thread: "chat-thread",
  input: "chat-input",
  send: "chat-send",
};

export const WHATSAPP_FAB = "whatsapp-fab";


export const REWARDS = {
  root: "rewards-hub",
  balance: "rewards-balance",
  balancePoints: "rewards-balance-points",
  balanceDollars: "rewards-balance-dollars",
  storesChips: "rewards-stores-chips",
  storeChip: (id) => `rewards-store-chip-${id}`,
  checkinCard: "rewards-checkin-card",
  checkinInput: "rewards-checkin-input",
  checkinBtn: "rewards-checkin-btn",
  receiptCard: "rewards-receipt-card",
  receiptAmount: "rewards-receipt-amount",
  receiptImageInput: "rewards-receipt-image-input",
  receiptSubmit: "rewards-receipt-submit",
  reviewCard: "rewards-review-card",
  reviewPlatform: "rewards-review-platform",
  reviewScreenshotInput: "rewards-review-screenshot-input",
  reviewSubmit: "rewards-review-submit",
  reviewOpenGoogle: "rewards-review-open-google",
  redeemCard: "rewards-redeem-card",
  redeemInput: "rewards-redeem-input",
  redeemBtn: "rewards-redeem-btn",
  codesList: "rewards-codes-list",
  codeItem: (id) => `rewards-code-${id}`,
  ledger: "rewards-ledger",
  ledgerItem: (id) => `rewards-ledger-item-${id}`,
};
